import { setContext } from '@apollo/client/link/context';

import { getCurrentIdToken } from '@/lib/auth/token-bridge';

import { isPublicGraphQLOperation } from './graphql-public-operations';

export const assertAuthTokenAvailable = (token: string): void => {
  if (!token) {
    throw new Error('Authentication token not available');
  }
};

export const createAuthLink = () =>
  setContext((operation, { headers }) => {
    if (isPublicGraphQLOperation(operation.operationName ?? undefined)) {
      return { headers: { ...headers } };
    }

    // getSession()（= /api/auth/session への HTTP fetch）を呼ばず、token-bridge の
    // module ref を同期的に read する。SessionProvider が SSOT であり、providers.tsx が
    // session 更新のたびに ref を最新化するため、常に最新トークンを fetch ゼロで取得できる。
    const token = getCurrentIdToken() ?? '';

    return {
      headers: {
        ...headers,
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    };
  });
